import React from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid as MuiGrid,
  styled
} from '@mui/material';

import { appEvents } from 'modules';
import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const ControlledTextField = fields.TextField.genControllerComponent<dataService.IFormState>();
const ControlledDateField = fields.DateField.genControllerComponent<dataService.IFormState>();

const Grid = styled(MuiGrid)(({ theme }) => ({
  paddingTop: theme.spacing(1)
}));



export interface IProps {
  accessPassId?: string;
}

export const FC: React.FC<IProps> = props => {
  const {
    form,
    loading,
    mutations
  } = dataService.useQuery(props.accessPassId);



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  function processSubmit(state: dataService.IFormState) {
    mutations.saveAccessPass(state);
    handleClose();
  }



  return (
    <Dialog
      open
      onClose={() => !loading && handleClose()}>
      <DialogTitle>
        Edit Access Pass
      </DialogTitle>

      <DialogContent>
        <form onSubmit={form.handleSubmit(processSubmit)}>
          <Grid
            container
            spacing={3}>
            <Grid
              item
              xs={6}>
              <ControlledTextField
                isDisabled={loading}
                fieldKey="email"
                formControl={form.control}
                type="email"
                label="Email" />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledTextField
                isDisabled={loading}
                fieldKey="note"
                formControl={form.control}
                label="Note" />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledDateField
                isDisabled={loading}
                fieldKey="startDate"
                label="Start Date"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledDateField
                isDisabled={loading}
                fieldKey="endDate"
                label="End Date"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}>
              <Button type="submit">
                Save
              </Button>
            </Grid>
          </Grid>
        </form>

      </DialogContent>
    </Dialog>
  );
};
